import getAnyOrVoid from 'utils/accessors/getAnyOrVoid.util';
import nullBind from 'utils/functions/nullBind.util';

const nameOf = nullBind(getAnyOrVoid, 'target.name');

const fromEventToName = ev => nameOf(ev);

// noinspection JSUnusedGlobalSymbols
export default fromEventToName;
